import { render, staticRenderFns } from "./settings-templates-labels.vue?vue&type=template&id=d234cd4a&"
import script from "./settings-templates-labels.ts?vue&type=script&lang=ts&"
export * from "./settings-templates-labels.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports